import PropTypes from "prop-types";

// material-ui
import Dialog from "@mui/material/Dialog";

// project-imports
import SimpleBar from "components/third-party/SimpleBar";
import CreateSupplierForm from "./create-supplier/CreateSupplierForm";

const CreateSupplierModal = ({
  open,
  modalToggler,
  mode = "create",
  supplierData = null,
  requireGst = false,
}) => {
  const closeModal = () => modalToggler(false);

  return (
    <Dialog open={open} onClose={closeModal} maxWidth="sm" fullWidth>
      <SimpleBar
        sx={{
          maxHeight: `calc(100vh - 48px)`,
          "& .simplebar-content": {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <CreateSupplierForm
          key={supplierData?.id || mode}
          closeModal={closeModal}
          mode={mode}
          supplierData={supplierData}
          requireGst={requireGst}
        />
      </SimpleBar>
    </Dialog>
  );
};

CreateSupplierModal.propTypes = {
  open: PropTypes.bool.isRequired,
  modalToggler: PropTypes.func.isRequired,
};

export default CreateSupplierModal;
